/** GraphQL fields for Polylang hreflang (uri + translations). */
export const POLYLANG_URI_FIELDS = `
  uri
  language {
    code
  }
  translations {
    uri
    language {
      code
    }
  }
`;
